module.exports = __webpack_public_path__ + "static/media/CORRECTOR.ab74ff14.svg";